const defaultConfig = {
  showName: '开12',
  backgroundColor: '#5257e9',
  iconPath: 'favicon.png',
  copyright: '',
  ClassStudentManagement: false, // 教师首页 班级学生管理卡片
  EvaluationSummaryTableDownload: false, // 综合评价-年级组 评价汇总表下载
  EvaluationReportDownload: true, // 综合评价-年级组 评价报告下载
  GuilinEvaluationReport: false, // 超级管理员-报告模板
  ReportTypeSet: false, // 记录类型设置
  commentsDouble: false, // 学生学期评语是否启用 肯定、差距 评价（衡水定制）
  studentRecordType: false, // 添加写实记录 记录类型是否显示（衡水定制）
  ResetPassword: true, // 找回密码
  groupEvaluation: false, // 班级小组评价是否显示（衡水验收定制）
  hengshuiEvaluationTable: false, // 衡水市用户综合评价定制
  HengshuiYanshou: false // 衡水验收定制表格显示
}
const regional = {
  wuxi: {
    showName: '无锡市',
    copyright: 'wuxi'
  },
  guilin: {
    showName: '桂林市',
    copyright: 'guilin',
    ClassStudentManagement: true,
    EvaluationSummaryTableDownload: true,
    GuilinEvaluationReport: true,
    ResetPassword: false
  },
  hengshui: {
    showName: '衡水市',
    copyright: 'hengshui',
    ReportTypeSet: false,
    studentRecordType: true,
    groupEvaluation: true,
    hengshuiEvaluationTable: true,
    HengshuiYanshou: true,
    disableCRUD: true // 禁用增删改查按钮
  }
}
const area = process.env.NODE_AREA // 当前服务地区
Object.assign(defaultConfig, regional[area])
export default defaultConfig



//////////////////
// WEBPACK FOOTER
// ./config/regional.configuration.js
// module id = null
// module chunks = 